module.exports = __webpack_public_path__ + "img/LENNY_KRAVITZ_16-9_15s.4a952805.jpg";